import { useMutation } from '@tanstack/react-query';
import { useApi } from '../useApi';

export function useGetStats() {
  const getApi = useApi();

  const getStats = async (projectId: string) => {
    const api = await getApi();
    return await api.controlStatisticsFindSummaryProject(projectId);
  };

  const mutation = useMutation(getStats, {});

  return mutation;
}
